import React, { PureComponent } from "react";

import Slot from "../../_molecules/Slot";
import ContentTitle from "../../_atoms/ContentTitle";

import { PromoSlotsContainer, PromoSlotsWrapper } from "./styled-components";

export default class FeaturedSlots extends PureComponent {
  static defaultProps = {
    qaLabel: "promoSlots"
  };

  render() {
    const { content, qaLabel } = this.props;

    return (
      <PromoSlotsWrapper data-qa-label={qaLabel}>
        <ContentTitle
          content={{
            header: content.header,
            className: "promoAllSlotsTitle"
          }}
          qaLabel={`${qaLabel}Title`}
        />
        <PromoSlotsContainer data-qa-label={`${qaLabel}Container`}>
          {content.slots.map((slot) => (
            <Slot
              key={slot._uid}
              isTopPromo={false}
              content={slot}
              qaLabel={`${slot.promoId || ""}-${qaLabel}PromoSlot`}
            />
          ))}
        </PromoSlotsContainer>
      </PromoSlotsWrapper>
    );
  }
}
